export interface CreatorSection {
    id: number;
    label: string;
    title: string;
    type: SectionType;
    align: AlignmentOption;
    value: string;
    subLabel: string;
    expanded: boolean;
    displayed: boolean;
    subLabelValue: string;
    direction: DirectionType;
    members: SectionMember[];
}

export interface SectionMember {
    id: number;
    type: MemberType;
    align: AlignmentOption;
    proportion?: ObjectProportions;
    title: string;
    value: any;
    mandatory?: boolean;
    options: MemberOption[];
    tag?: ModelTag;
    isQuestion?: boolean;
}

export interface SectionType {
    id: number;
    value: string;
    label: string;
}

export interface DirectionType {
    id: number;
    type: string;
    label: string;
}

export interface MemberType {
    id: number;
    type: string;
    label: string;
}

export interface MemberOption {
    id: number;
    label: string;
    value: any;
}

export interface AlignmentOption {
    id: number;
    label: string;
    value: string;
}

export interface ObjectProportions {
    id: number;
    value: number;
}

export interface ModelTag {
    id: number;
    label: string;
    value: string;
}

export const defaultMemberTypes: MemberType[] = [{id: 1, type: 'text', label: 'Κείμενο'}, {id: 2, type: 'checkbox', label: 'Πολλαπλής επιλογής'}, {
    id: 3,
    type: 'radio',
    label: 'Απλής επιλογής'
}, {id: 4, type: 'toggle', label: 'OXI/NAI'}, {id: 5, type: 'select', label: 'Dropdown'}, {id: 6, type: 'textarea', label: 'Περιοχή κειμένου'}, {id: 7, type: 'label', label: 'Ετικέτα'}, {
        id: 8,
        type: 'image',
        label: 'Εικόνα'
    }];

export const defaultDirectionTypes: DirectionType[] = [{id: 1, type: 'start start center', label: 'Αρχή'}, {id: 2, type: 'center start center', label: 'Κέντρο'}, {
    id: 3,
    type: 'end start center',
    label: 'Τέλος'
}];

export const defaultSectionTypes: SectionType[] = [{id: 1, value: 'row', label: 'Γραμμή'}, {id: 1, value: 'column', label: 'Στήλη'}];
export const defaultAlignOptions: AlignmentOption[] = [{id: 1, value: 'flex-start', label: 'Αριστερά'}, {id: 2, value: 'center', label: 'Κέντρο'}, {id: 3, value: 'flex-end', label: 'Δεξιά'}];
export const defaultProportions: ObjectProportions[] = [{id: 1, value: 25}, {id: 2, value: 50}, {id: 3, value: 75}, {id: 4, value: 100}];
export const defaultTags: ModelTag[] = [
    {id: 1, label: 'Όνομα χρήστη', value: '[user-first-name]'},
    {id: 2, label: 'Επώνυμο χρήστη', value: '[user-last-name]'},
    {id: 3, label: 'Ονοματεπώνυμο χρήστη', value: '[user-displayName]'},
    {id: 4, label: 'Τηλέφωνο χρήστη', value: '[user-telephone]'},
    {id: 5, label: 'Email χρήστη', value: '[user-email]'},
];
